import { render, staticRenderFns } from "./HouseholdResultGrid.vue?vue&type=template&id=31f71311"
import script from "./HouseholdResultGrid.vue?vue&type=script&lang=js"
export * from "./HouseholdResultGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports